import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import {
    subheadlineFontFamily,
    subheadlineFontWeight,
    subheadlineLetterSpacing,
    subheadlineLineHeight,
    subheadlineXxlFontSize,
    subheadlineXlFontSize,
    subheadlineLargeFontSize,
    subheadlineMediumFontSize,
    subheadlineSmallFontSize,
    subheadlineXsFontSize,
} from 'common/styles/typography';

const SUBHEADLINE_SIZES = {
    xxl: subheadlineXxlFontSize,
    xl: subheadlineXlFontSize,
    large: subheadlineLargeFontSize,
    medium: subheadlineMediumFontSize,
    small: subheadlineSmallFontSize,
    xs: subheadlineXsFontSize,
};

const withSubheadlineStyles = (StyledComponent) =>
    styled(StyledComponent)`
        font-family: ${subheadlineFontFamily};
        font-weight: ${({ $fontWeight }) => $fontWeight || subheadlineFontWeight};
        line-height: ${subheadlineLineHeight};
        letter-spacing: ${subheadlineLetterSpacing};
        font-size: ${(styledProps) => SUBHEADLINE_SIZES[styledProps.size]};
    `;

// These are separted to avoid defining the components in the render
const subheadlineStyledComponents = {
    p: withSubheadlineStyles(styled.p``),
};

export const Subheadline = ({ tag, size, fontWeight, ...props }) => {
    const StyledComponent = subheadlineStyledComponents[tag];

    return <StyledComponent {...props} size={size} $fontWeight={fontWeight} />;
};

Subheadline.propTypes = {
    tag: PropTypes.oneOf(Object.keys(subheadlineStyledComponents)),
    children: PropTypes.node,
    size: PropTypes.oneOf(Object.keys(SUBHEADLINE_SIZES)),
    fontWeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

Subheadline.defaultProps = {
    tag: 'p',
    children: null,
    size: 'medium',
    fontWeight: null,
};
